<template>
    <div class="diagnosis-analysis">
        <div class="tag-panel theme-tcm">
            <p class="panel-tit">{{ tcm.title }}</p>
            <div
                v-for="(row, index) in tcm.rows"
                :key="'tcm-' + index"
                class="tag-row"
            >
                <span class="row-label">{{ row.label }}</span>
                <div class="tag-list">
                    <span
                        v-for="(tag, tagIndex) in row.tags"
                        :key="'tcm-tag-' + tagIndex"
                        class="tag-item"
                    >{{ tag }}</span>
                </div>
            </div>
        </div>
        <div class="tag-panel theme-western">
            <p class="panel-tit">{{ western.title }}</p>
            <div
                v-for="(row, index) in western.rows"
                :key="'western-' + index"
                class="tag-row"
            >
                <span class="row-label">{{ row.label }}</span>
                <div class="tag-list">
                    <span
                        v-for="(tag, tagIndex) in row.tags"
                        :key="'western-tag-' + tagIndex"
                        class="tag-item"
                    >{{ tag }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import diagnosisAnalysisData from '../mock/diagnosisAnalysis.json';

export default {
    name: 'DiagnosisAnalysis',
    data() {
        return {
            chartData: diagnosisAnalysisData,
        };
    },
    computed: {
        tcm() {
            return this.chartData.tcm || { title: '中医诊断标签区', rows: [] };
        },
        western() {
            return this.chartData.western || { title: '西医诊断标签区', rows: [] };
        },
    },
};
</script>

<style lang="less" scoped>
.diagnosis-analysis {
    display: flex;
    gap: 16px;
    align-items: stretch;
}

.tag-panel {
    flex: 1 1 0;
    min-width: 0;
    background: #fff;
    border: 1px solid #E8EEF8;
    border-radius: 10px;
    padding: 14px 16px 16px;
    box-sizing: border-box;
}

.panel-tit {
    margin: 0 0 14px;
    font-size: 14px;
    font-weight: bold;
    color: #0C55AA;
    line-height: 20px;
}

.tag-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;

    &:last-child {
        margin-bottom: 0;
    }
}

.row-label {
    flex: 0 0 72px;
    width: 72px;
    padding-top: 4px;
    font-size: 13px;
    color: #165DFF;
    line-height: 22px;
    white-space: nowrap;
}

.tag-list {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.tag-item {
    display: inline-block;
    padding: 3px 10px;
    font-size: 12px;
    line-height: 20px;
    border-radius: 4px;
    border: 1px solid transparent;
    box-sizing: border-box;
}

.theme-tcm {
    .tag-item {
        color: #059669;
        background: #ECFDF5;
        border-color: #6EE7B7;
    }
}

.theme-western {
    .tag-item {
        color: #2563EB;
        background: #EFF6FF;
        border-color: #93C5FD;
    }
}
</style>
